<template>
  <div>
    <vs-card>
      <template v-slot:header>
        <vs-row>
          <span><b>IDAM 2.0 user segmentation</b></span>
          <vs-spacer />
          <div>{{ isQueryValid ? "Valid" : "Incomplete query" }}</div>
        </vs-row>
      </template>

      <div v-auto-animate v-if="userQueryInfo">
        <div v-for="(queryEntry, idx) in query.userQueryEntries" :key="idx">
          <vs-divider border-style="dashed" class="text-sm" v-if="idx > 0"> or </vs-divider>

          <SegmentationGroup v-model="query.userQueryEntries[idx]" :canRemoveGroup="idx > 0" @onDelete="deleteQueryEntry(idx)" />
        </div>
      </div>

      <div class="flex justify-center mt-2">
        <vs-tooltip text="Add new segmentation group">
          <vs-button type="flat" icon="icon-plus-circle" icon-pack="feather" @click="addNewQueryEntry" />
        </vs-tooltip>
      </div>
    </vs-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import SegmentationGroup from "./SegmentationGroup";

export default {
  components: {
    // Treeselect,
    SegmentationGroup
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    deactivateAll: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      // query: {
      //   userQueryEntries: [
      //     {
      //       hasIdamRole: true,
      //       hasIdamRoleForEntity: true,
      //       hasPosition: true,
      //       hasTag: true,
      //       hasIsHiredAt: true,
      //       idamRoleId: null,
      //       idamRoleIdForEntity: null,
      //       idamRoleForEntityType: null,
      //       idamRoleForEntityId: null,
      //       position: null,
      //       tags: ["test", "test2"],
      //       isHiredAtEntityType: null,
      //       isHiredAtEntityId: null,
      //     },
      //   ],
      // },
      query: this.value
    };
  },
  methods: {
    addNewQueryEntry() {
      this.query.userQueryEntries.push({
        hasIdamRole: false,
        hasIdamRoleForEntity: false,
        hasPosition: false,
        hasTag: false,
        hasIsHiredAt: false,
        idamRoleId: null,
        idamRoleIdForEntity: null,
        idamRoleForEntityType: null,
        idamRoleForEntityId: null,
        position: null,
        tags: [],
        isHiredAtEntityType: null,
        isHiredAtEntityId: null
      });
    },
    deleteQueryEntry(idx) {
      this.query.userQueryEntries.splice(idx, 1);
    }
  },
  computed: {
    ...mapGetters({
      userQueryInfo: "userQueries/userQueryInfo"
    }),
    isQueryValid() {
      let queryValid = true;

      for (const queryEntry of this.query.userQueryEntries) {
        if (queryEntry.hasIdamRole && !queryEntry.idamRoleId) {
          console.log("Invalid idamRole", queryEntry.idamRoleId);
          queryValid = false;
          break;
        }

        if (
          queryEntry.hasIdamRoleForEntity &&
          (!queryEntry.idamRoleIdForEntity || !queryEntry.idamRoleForEntityType || !queryEntry.idamRoleForEntityId)
        ) {
          console.log(
            "Invalid idamRoleForEntity",
            queryEntry.idamRoleIdForEntity,
            queryEntry.idamRoleForEntityType,
            queryEntry.idamRoleForEntityId
          );
          queryValid = false;
          break;
        }

        if (queryEntry.hasPosition && !queryEntry.position) {
          console.log("Invalid position", queryEntry.position);
          queryValid = false;
          break;
        }

        if (queryEntry.hasTag && (!queryEntry.tags || queryEntry.tags.length === 0)) {
          console.log("Invalid tags", queryEntry.tags);
          queryValid = false;
          break;
        }

        if (queryEntry.hasIsHiredAt && (!queryEntry.isHiredAtEntityType || !queryEntry.isHiredAtEntityId)) {
          console.log("Invalid isHiredAt", queryEntry.isHiredAtEntityType, queryEntry.isHiredAtEntityId);
          queryValid = false;
          break;
        }
      }

      console.log("Emitting valid", queryValid);
      this.$emit("validQuery", queryValid);
      return queryValid;
    }
  },
  async mounted() {
    this.$vs.loading({});
    await this.$store.dispatch("userQueries/getUserQueryInfo");
    this.$vs.loading.close();
  }
};
</script>

